module.exports = __webpack_public_path__ + "img/icon-user.5d819bd0.svg";